import Repository from './Repository'

import { getHeaders } from '@/legacy/repositories/advertiserRepository'

const resource = '/profiles'

export default {
  assignUserTag(token, profileId, tagId) {
    return Repository(getHeaders(token)).put(`${resource}/${profileId}/user-tags/${tagId}`)
  },
  removeUserTag(token, profileId, tagId) {
    return Repository(getHeaders(token)).delete(`${resource}/${profileId}/user-tags/${tagId}`)
  },
}
